import { designSystemColors, otherColors } from '@klv/shared/styles/colors';

const topicsMenu = {
  default: {
    background: 'transparent',
    color: designSystemColors.charcoal,
    mobileInputBorder: '#D1D5DB',
  },
  hover: {
    mobileInputBorder: '#D1D5DB',
    background: otherColors.fadedCharcoal15,
    color: designSystemColors.charcoal,
  },
  selected: {
    background: designSystemColors.charcoal,
    color: designSystemColors.white,
  },
};

export default topicsMenu;
